export default __webpack_public_path__ + "static/media/character.453e9d97.png";